import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action
export const insertMultipleQuotationEntry = createAsyncThunk('insertMultipleQuotationEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertMultipleQuotationEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchMultipleQuotMemo = createAsyncThunk('fetchMultipleQuotMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getQuotMultiMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMultipleQuotationData = createAsyncThunk('fetchMultipleQuotationData', async (id) => {
    try {
        const endpoint = id ? `getMultipleQuotationData&mqtId=${id}` : 'getMultipleQuotationData';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const multipleQuotSlice = createSlice({
    name: 'multipleQuotData',
    initialState: {
        isLoading: false,
        mqtMemo: null,
        mqtData: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMultipleQuotMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMultipleQuotMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.mqtMemo = action.payload;
        });
        builder.addCase(fetchMultipleQuotMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchMultipleQuotationData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMultipleQuotationData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.mqtData = action.payload;
        });
        builder.addCase(fetchMultipleQuotationData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default multipleQuotSlice.reducer;
